<template>
    <b-form-group v-if="hasFormGroup"
                  :label="computedLabel"
                  label-for="selected-device-states-select">

        <multiselect
            id="selected-device-states-select"
            placeholder="-"
            :searchable="false"
            :show-no-results="true"
            :allowEmpty="allowEmpty"
            :disabled="disabled || loading"
            open-direction="bottom"
            :options="options"
            v-model="selectedOption"
            track-by="value"
            label="label"
            :multiple="true"
        >
            <template slot="tag" slot-scope="{ option, remove }">
                <span class="multiselect__tag">
                  {{ option.label }}
                  <i
                      v-if="!disabledOptionsRemoval.includes(option.value)"
                      class="multiselect__tag-icon"
                      @click.prevent.stop="remove(option)"
                  ></i>
                </span>
            </template>

            <template #clear v-if="showClearIcon">
                <div
                    class="multiselect__clear"
                    @mousedown.prevent.stop="clearValue"
                ></div>
            </template>

        </multiselect>
    </b-form-group>

    <multiselect
        v-else
        id="selected-device-states-select"
        placeholder="-"
        :searchable="false"
        :show-no-results="true"
        :allowEmpty="allowEmpty"
        :disabled="disabled || loading"
        open-direction="bottom"
        :options="options"
        v-model="selectedOption"
        track-by="value"
        label="label"
        :multiple="true"
    >

        <template slot="tag" slot-scope="{ option, remove }">
            <span class="multiselect__tag">
              {{ option.label }}
              <i
                  v-if="!disabledOptionsRemoval.includes(option.value)"
                  class="multiselect__tag-icon"
                  @click.prevent.stop="remove(option)"
              ></i>
            </span>
        </template>

        <template #clear v-if="showClearIcon">
            <div
                class="multiselect__clear"
                @mousedown.prevent.stop="clearValue"
            ></div>
        </template>

    </multiselect>
</template>
<script>

import Multiselect from "vue-multiselect";
import {RTStatesEnum} from "../js/enums";

export default {
    name: "SelectedDeviceStatesSelect",
    components: {
        Multiselect,
    },
    props: {
        label: {
            type: String,
            required: false,
            default: ''
        },
        tLabel: {
            type: String,
            required: false,
            default: ''
        },
        hasFormGroup: {
            type: Boolean,
            required: false,
            default: true
        },
        allowEmpty: {
            type: Boolean,
            required: false,
            default: true
        },
        disabledOptionsRemoval: {
            type: Array,
            required: false,
            default: () => []
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        value: {
            type: Array,
            required: true,
        },
        allowedOptions: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    data() {
        return {
            loading: true,
            ready: true,
            selectedOption: [],
            options: [
                {
                    value: RTStatesEnum.SERIALIZZATO,
                    label: this.$t(RTStatesEnum.SERIALIZZATO),
                },
                {
                    value: RTStatesEnum.CENSITO,
                    label: this.$t(RTStatesEnum.CENSITO),
                },
                {
                    value: RTStatesEnum.FISCALIZZATO,
                    label: this.$t(RTStatesEnum.FISCALIZZATO),
                },
                {
                    value: RTStatesEnum.ATTIVATO,
                    label: this.$t(RTStatesEnum.ATTIVATO),
                },
                {
                    value: RTStatesEnum.IN_SERVIZIO,
                    label: this.$t(RTStatesEnum.IN_SERVIZIO),
                },
                {
                    value: RTStatesEnum.FUORI_SERVIZIO,
                    label: this.$t(RTStatesEnum.FUORI_SERVIZIO),
                },
                {
                    value: RTStatesEnum.DISATTIVATO,
                    label: this.$t(RTStatesEnum.DISATTIVATO),
                },
                {
                    value: RTStatesEnum.DISMESSO,
                    label: this.$t(RTStatesEnum.DISMESSO)
                }
            ],
        }
    },
    mounted() {
        this.$emit("ready", this.ready);
        this.loading = false;

        if (this.allowedOptions.length) {
            this.options = this.options.filter(v => this.allowedOptions.includes(v.value));
        }

        if (this.value.length) {
            this.selectedOption = this.findByValue(this.value);
        }
    },
    methods: {
        clearValue() {
            this.selectedOption = [];
        },
        findByValue(value) {
            if (!value || !value.length) {
                return [];
            }

            return this.options.filter(options => value.includes(options?.value)) || [];
        }
    },
    computed: {
        computedLabel() {
            return this.tLabel ? this.$t(this.tLabel) : this.label;
        },
        showClearIcon() {
            return this.allowEmpty && this.selectedOption.length;
        },
    },
    watch: {
        selectedOption(newValue) {
            const newValues = newValue.map(item => item.value);

            if (JSON.stringify(newValues) !== JSON.stringify(this.value)) {
                this.$emit("input", newValues);
            }
        },
        value(newValue) {
            const foundValues = this.findByValue(newValue);

            if (JSON.stringify(foundValues) !== JSON.stringify(this.selectedOption)) {
                this.selectedOption = foundValues;
            }
        }
    }
};
</script>
